import React from 'react';
import { withRouter } from 'react-router';
import autoBind from 'react-autobind';
import ClientTypeStore from '../stores/ClientTypeStore';
import RadioButtonList from '../components/Common/RadioButtonList.jsx';
import Transitions from '../core/Transitions';
import SelectCustomerConstants from '../constants/SelectCustomerConstants.js';
import ClientApiCallbackActions from '../actions/ClientApiCallbackActions';
import ClientSearchActions from '../actions/ClientSearchActions';
import ApplicationConstants from '../constants/ApplicationConstants';
import Spinner from './Common/Spinner.jsx';
import SlidingSessionNotification from './SlidingSessionNotification.jsx';
import OmnitureTracking from '../utils/OmnitureTracking.js';

const Constants = SelectCustomerConstants;

function getState() {
    return ClientTypeStore.getStore();
}

class ClientType extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getState();
    }

    componentDidMount() {
        ClientTypeStore.addChangeListener(this._onChange);
        OmnitureTracking.getTrackingEnabled();
    }

    componentWillUnmount() {
        ClientTypeStore.removeChangeListener(this._onChange);
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.canTransit) {
            Transitions.forwardFromClientType(this.props.router,
            {
                applicationLinkType: nextState.applicationLinkType,
                productId: nextState.productId,
                searchResult: nextState.searchResult
            });
            return;
        }

        // try to search and match pre-populated exisiting and listed client for Iress (XPLAN)
        if (nextState.clientSearchQuery) {
            ClientSearchActions.searchClient(nextState.clientSearchQuery);
        }
    }

    _onChange() {
        this.setState(getState());
    }

    _onSelect(event) {
        ClientApiCallbackActions.setApplicationLinkType(event.target.value);
    }

    _renderSpinner() {
        return (
            <div className="row">
                <div className="col-md-8 col-md-offset-2">
                    <h2>Client search</h2>
                </div>
                <div className="col-md-2 col-md-offset-5">
                    <Spinner size={ApplicationConstants.SpinnerSizes.Three} />
                </div>
            </div>
        );
    }
    
    _renderClientTypeOptions() {
        return (
            <div className="row">
                <div className="col-md-8 col-md-offset-2">
                    <RadioButtonList data={Constants.ClientTypeOptions}
                        handleChange={this._onSelect}
                        id="clientOptionsList"
                        label="Is this application to be linked?"
                        name="clientOptionsList"
                        useHeadingStyle={true} />
                </div>
            </div>);
    }

    render() {
        return (
            <div className= "start" >
                <div className="container">
                    <SlidingSessionNotification />
                    {this.state.isLoading ? this._renderSpinner() : this._renderClientTypeOptions()}
                </div>
            </div>);
    }
}

export default withRouter(ClientType)


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ClientType.jsx